import BaseTemplate from '@/kyna/layouts/BaseTemplate';
import NewsEvents from '@/kyna/view/_public/NewsEvents';

export default function News_Events() {
  return (
    <BaseTemplate title="News and Events" body={<NewsEvents />} />
  )
}
